/**
 * ============================================================
 * Unhinged Mugs — Product Page Enhancements
 * File: assets/um-product-enhancements.js
 *
 * Add to theme: Online Store → Themes → Edit code → Assets
 * Then reference before </body> in theme.liquid with:
 *   {{ 'um-product-enhancements.js' | asset_url | script_tag }}
 * ============================================================
 */

(function () {
  'use strict';

  /* ============================================================
     SECTION 0: Thumbnail Gallery
     Handles clicks on .um-product__thumb buttons to swap the
     main product image without any dependency on Horizon components.
     ============================================================ */

  function initGallery() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.um-product__thumb');
      if (!thumb) return;

      var imageUrl = thumb.dataset.imageUrl;
      if (!imageUrl) return;

      // Swap main image
      var mainImg = document.querySelector('.um-product__main-image img');
      if (mainImg) {
        mainImg.src = imageUrl;
        var alt = thumb.dataset.imageAlt;
        if (alt) mainImg.alt = alt;
      }

      // Update active thumbnail
      document.querySelectorAll('.um-product__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  }


  /* ============================================================
     SECTION 1: Color Swatch Selector
     Fetches the Shopify product JSON once to build a
     color-name → { imageSrc, variantId } lookup, then on each
     swatch click directly updates the gallery image, the hidden
     variant ID input, and the page URL — no Horizon custom
     element required.
     ============================================================ */

  // Shared map: colorName (string) → { src: string, variantId: number }
  var _colorMap = {};
  var _mapReady = false;
  var _pendingColor = null; // color clicked before map was ready

  function buildColorMap(handle) {
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var images   = data.product.images;
        var variants = data.product.variants;

        // Build variantId → first matching image src
        var idToSrc = {};
        images.forEach(function (img) {
          img.variant_ids.forEach(function (vid) {
            if (!idToSrc[vid]) idToSrc[vid] = img.src;
          });
        });

        // Build colorName → { src, variantId }
        variants.forEach(function (v) {
          // Color is the last option in the title ("15oz / Black" → "Black")
          var parts = v.title.split(' / ');
          var color = parts[parts.length - 1].trim();
          _colorMap[color] = {
            src:       idToSrc[v.id] || null,
            variantId: v.id
          };
        });

        _mapReady = true;

        // Apply any click that happened while we were fetching
        if (_pendingColor) {
          applyColorChange(_pendingColor);
          _pendingColor = null;
        }
      })
      .catch(function (err) {
        console.warn('[UM] Could not load product JSON:', err);
        _mapReady = true; // let pending clicks fall through gracefully
      });
  }

  function applyColorChange(colorName) {
    var info = _colorMap[colorName];

    // ---- 1. Update main gallery image ----
    if (info && info.src) {
      var mainImg = document.querySelector('.um-product__main-image img');
      if (mainImg) mainImg.src = info.src;

      // Match thumbnail by filename and mark it active
      var colorFile = info.src.split('/').pop().split('?')[0];
      document.querySelectorAll('.um-product__thumb').forEach(function (t) {
        var tFile = (t.dataset.imageUrl || '').split('/').pop().split('?')[0];
        t.classList.toggle('is-active', tFile === colorFile);
      });
    }

    // ---- 2. Check the native radio (keeps the form in sync) ----
    var radio = document.querySelector(
      'input[type="radio"][name="options[color]"][value="' + colorName + '"]'
    );
    if (radio) radio.checked = true;

    // Update native swatch active class so Shopify's own styling stays correct
    document.querySelectorAll('.um-product__swatch').forEach(function (s) {
      var r = s.querySelector('input[type="radio"]');
      s.classList.toggle('is-active', !!(r && r.value === colorName));
    });

    // ---- 3. Update hidden variant ID input (for ATC form submission) ----
    if (info) {
      var hiddenId = document.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = info.variantId;
    }

    // ---- 4. Update the page URL ----
    if (info) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', info.variantId);
      history.replaceState({}, '', url.toString());
    }
  }

  function initColorSelector() {
    var selector = document.querySelector('.um-color-selector');
    if (!selector) return;

    var swatches     = selector.querySelectorAll('.um-swatch');
    var toggleBtn    = selector.querySelector('#um-more-toggle');
    var selectedName = selector.querySelector('.um-selected-color-name');

    // Derive product handle from the URL (/products/<handle>)
    var pathParts = window.location.pathname.split('/products/');
    var handle    = pathParts.length > 1 ? pathParts[1].split('?')[0].split('/')[0] : null;
    if (handle) buildColorMap(handle);

    // ---- Swatch click handler ----
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.classList.contains('um-swatch--soldout')) return;

        var colorName = swatch.dataset.colorName;

        // Update visual state on our custom swatches
        swatches.forEach(function (s) {
          s.classList.remove('um-swatch--active');
          s.setAttribute('aria-checked', 'false');
        });
        swatch.classList.add('um-swatch--active');
        swatch.setAttribute('aria-checked', 'true');

        // Update the selected-color label
        if (selectedName) selectedName.textContent = colorName;

        // Apply gallery + form + URL update
        if (_mapReady) {
          applyColorChange(colorName);
        } else {
          // Map still loading — queue it
          _pendingColor = colorName;
        }
      });
    });

    // ---- "5 more colors" toggle ----
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        var hidden = selector.querySelectorAll('.um-swatch--hidden');

        hidden.forEach(function (s) {
          if (isExpanded) {
            s.classList.remove('um-swatch--revealed');
          } else {
            s.classList.add('um-swatch--revealed');
          }
        });

        toggleBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        var lbl = toggleBtn.querySelector('.um-more-toggle__label');
        if (lbl) {
          lbl.textContent = isExpanded
            ? (toggleBtn.dataset.labelMore || 'More colors')
            : (toggleBtn.dataset.labelLess || 'Show fewer colors');
        }
      });
    }
  }


  /* ============================================================
     SECTION 2: Free Shipping Incentive
     ============================================================ */

  function initShippingIncentive() {
    var incentive = document.getElementById('um-shipping-incentive');
    if (!incentive) return;

    var lockedEl   = document.getElementById('um-shipping-locked');
    var unlockedEl = document.getElementById('um-shipping-unlocked');
    var barFill    = incentive.querySelector('.um-shipping-incentive__bar-fill');
    var NEED       = parseInt(incentive.dataset.needUnits, 10) || 2;

    var qtyInput = document.querySelector(
      'input[name="quantity"], .quantity__input, [data-quantity-input]'
    );

    var cartUnits = 0; // units already in the cart (fetched below)

    function currentQty() {
      return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    }

    // Counts cart contents + the quantity selected on this page, so the
    // message is true for the order the customer is actually building.
    function render() {
      var units = cartUnits + currentQty();
      if (units >= NEED) {
        lockedEl.style.display   = 'none';
        unlockedEl.style.display = '';
        incentive.classList.add('is-unlocked');
        if (barFill) barFill.style.width = '100%';
      } else {
        var needed  = NEED - units;
        var mugWord = needed === 1 ? 'mug' : 'mugs';
        var textEl  = lockedEl.querySelector('.um-shipping-incentive__text');
        if (textEl) {
          textEl.innerHTML = 'Add <strong>' + needed + ' more ' + mugWord + '</strong> — ' + NEED + '+ mugs ship free.';
        }
        if (barFill) barFill.style.width = Math.min(units / NEED * 100, 100) + '%';
        lockedEl.style.display   = '';
        unlockedEl.style.display = 'none';
        incentive.classList.remove('is-unlocked');
      }
    }

    function syncCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) { cartUnits = c.item_count; render(); } })
        .catch(function () {});
    }

    render();
    syncCart();

    if (qtyInput) {
      qtyInput.addEventListener('change', render);
      qtyInput.addEventListener('input', render);
    }

    // The +/- steppers set the input's value programmatically (no input/change
    // event fires), so recompute after any click inside the quantity wrap.
    var qtyWrap = qtyInput && qtyInput.closest('.um-product__qty-wrap');
    if (qtyWrap) {
      qtyWrap.addEventListener('click', function () { setTimeout(render, 0); });
    }

    // Stay in sync when something is added/removed elsewhere (upsell, drawer).
    document.addEventListener('cart:update', syncCart);
  }


  /* ============================================================
     INIT
     ============================================================ */

  function init() {
    initGallery();
    initColorSelector();
    initShippingIncentive();
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init if Shopify re-renders the product section in the theme editor
  document.addEventListener('shopify:section:load', init);

})();

